module.exports = __webpack_public_path__ + "web/img/code-en.7053dcf8.jpg";